<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    withDefaults(
        defineProps<{
            shouldBeVisible?: boolean;
        }>(),
        {
            shouldBeVisible: undefined,
        }
    );

    const fetchAntibiotikaprofylax = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/antibiotikaprofylax/fetchAntibiotikaprofylax", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/antibiotikaprofylax/antibiotikaprofylaxSubset"]({
                subsetName,
                displayMode: true,
            });
        } catch (error) {
            flashWarning("Kunde inte hämta antibiotikaprofylax");
        }
    };
</script>

<template>
    <KAutocomplete
        name="antibiotikaprofylax"
        label="Antibiotikaprofylax"
        v-bind="$attrs"
        :options="fetchAntibiotikaprofylax"
        :converter="defaultAutocompleteConverter"
        :shouldBeVisible="shouldBeVisible"
    />
</template>

<style lang="scss" scoped></style>
